import { Modal, ModalHeader, ModalBody } from "reactstrap";

export default function ModalOrientationApple(props) {
  const { isOpen, toggle } = props;

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
        <ModalHeader toggle={toggle}>Orientações Apple</ModalHeader>
        <ModalBody>
          <ol className="ps-3">
            <li>
              Acessar{" "}
              <a
                href="https://developer.apple.com/"
                target="_blank"
                rel="noreferrer"
              >
                Apple Developer
              </a>{" "}
              com conta de usuário vinculada à Inteegra e selecionar a opção{" "}
              <strong>"Certificates, Identifiers & Profiles"</strong> no menu
              do usuário.
            </li>

            <li className="mt-3">
              <strong>Criar APP:</strong>
              <ul>
                <li>Selecionar a opção Identifiers</li>
                <li>Opção +</li>
                <li>ID APPs</li>
                <li>
                  APP (Inserir Descrição/Bundle e marcar Push Notifications)
                </li>
              </ul>
            </li>

            <li className="mt-3">
              <strong>Criar APP Notification:</strong>
              <ul>
                <li>Selecionar a opção Identifiers</li>
                <li>Opção +</li>
                <li>ID APPs</li>
                <li>
                  APP (Inserir Descrição/Bundle com texto{" "}
                  <strong>.Notification</strong> no final e marcar Push
                  Notifications)
                </li>
              </ul>
            </li>

            <li className="mt-3">
              <strong>Criar Certificado APP:</strong>
              <ul>
                <li>Selecionar a opção Profiles</li>
                <li>Opção +</li>
                <li>
                  Em Distribution selecionar a opção App Store Connect
                </li>
                <li>Selecionar o Bundle ID do APP</li>
                <li>Selecionar o certificado com maior data de validade</li>
                <li>
                  Inserir Provision Name (ProvisionProfile*Final do Bundle*)
                </li>
              </ul>
            </li>

            <li className="mt-3">
              <strong>Criar Certificado APP Notification:</strong>
              <ul>
                <li>Selecionar a opção Profiles</li>
                <li>Opção +</li>
                <li>
                  Em Distribution selecionar a opção App Store Connect
                </li>
                <li>Selecionar o Bundle ID do APP Notification</li>
                <li>Selecionar o certificado com maior data de validade</li>
                <li>
                  Inserir Provision Name (ProvisionProfile*Final do
                  Bundle.Notification*)
                </li>
              </ul>
            </li>
          </ol>
        </ModalBody>
      </Modal>
    </>
  );
}
